import script from "./UploadArt.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadArt.vue?vue&type=script&setup=true&lang=ts"

import "./UploadArt.vue?vue&type=style&index=0&id=5c608ecb&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c608ecb"]])

export default __exports__